import performLogout from './logout';

const redirectToLogin = () => {
  window.location.href = '/login';
};

const handleLogoutClick = async (event: Event) => {
  const target = (event.target as HTMLElement | null)?.closest('[data-logout-link]') as HTMLAnchorElement | null;

  if (!target) {
    return;
  }

  event.preventDefault();

  try {
    await performLogout();
    redirectToLogin();
  } catch (error) {
    console.error('Logout via data-logout-link failed:', error);
    window.location.href = target.href || '/logout';
  }
};

document.addEventListener('click', handleLogoutClick);

export default handleLogoutClick;
